/* eslint-disable no-magic-numbers */
// 百度地图ak
export const BAIDU_MAP_AK = '6N54N3ujNCfK9bKovNfqRcOnCHuoBoX7'

// 供应商注册tab页数据'提交'标志位
export const cs = 'cs' // 公司
export const ps = 'ps' // 个人
export const hs = 'hs' // 港澳台
export const os = 'os' // 非营利机构

export const ZERO = '0'
export const ONE = '1'
export const TWO = '2'
export const THREE = '3'
export const FOUR = '4'

export const ALLVEHICLE = '全部车辆'
export const OWNVEHICLE = '自有车辆'
export const LINKEDVEHICLE = '挂靠车辆'
export const CASUALVEHICLE = '临时车辆'
// 数据字典对应的值
// 供应商类型 =======> 物流供应商
export const LOGISTICS_SUPPLIER = '70'

// 供应商类型 =======> 内部供应商
export const INNER_SUPPLIER = '100'

// 供应商类型 =======> 基建及设备供应商
export const DEVICE_SUPPLIER = '40'

// 业务类型 =====> 仓储
export const STORAGE = '仓储'

// 业务类型 =====> 运输
export const TRANSPORTATION = '运输'

// 业务类型 =====> 快递
export const EXPRESS = '快递'

// 业务类型 =====> 装卸
export const LOAD_AND_UNLOAD = '装卸'

// 业务类型 =====> 配送
export const DISPATCH = '配送'

// 业务类型 =====> 资产转卖
export const RESOLD = '资产转卖'

// 业务类型 =====> 服务
export const SERVE = '服务'

// 业务类型 =====> 机器人
export const ROBOT = '机器人'

// 业务类型 =====> 宅配
export const HOME_DELIVERY = '宅配'

// 业务类型 =====> 其他业务
export const OTHER_BUSINESS = '其他业务'

// 业务类型 =====> 运输
export const TRANSPORTATION_NUM = '3'

// 业务类型 =====> 配送
export const DELIVERY_NUM = '4'

// 业务类型 =====> 快递
export const EXPRESS_NUM = '5'

// 业务类型 =====> 宅配
export const HOME_DELIVERY_NUM = '10'

// 业务类型 =====> 仓储
export const STORAGE_NUM = '1'

// 业务类型 =====> 装卸
export const LOAD_AND_UNLOAD_NUM = '2'

// SRM_BUSYNESS_TYPE_NO_LOGISTICS
// 业务类型(非物流) =====> 设备类
export const DEVICE_NUM = '11'

// 业务类型(非物流) =====> 设备租赁
export const DEVICE_LEASE_NUM = '14'

// 业务类型 =====> 电商
export const DS_NUM = '21';

// 业务类型 =====> 报关
export const BG_NUM = '22';

// 运输方式 =====> 海运
export const SEA_TRANSPORTATION_NUM = '10'

// 运输方式 =====> 海运
export const SEA_TRANSPORTATION = '海运'

// 合作方式 ======> 仓库管理
export const LEASING_MANAGEMENT_NUM = '1'

// 合作方式 ======> 仓库租赁
export const LEASING_STORAGE_NUM = '2'

// 合作方式 ======> 仓库租赁
export const LEASING_STORAGE = '2'

// 合作方式 ======> 仓管及仓租
export const LEASING_STORAGE_LEASE_NUM = '3'

// 日期永久有效
export const DATE_FOREVER = '2099-12-31'

// 主体性质 ======> 个体
export const PERSON = '2'
export const PERSON_TEXT = '国内（个人）'

// 主体性质 =======> 公司/法人
export const COMPANY = '1'
export const COMPANY_TEXT = '国内（公司、个体户）'

// 主体性质 =======> 国外
export const ABROAD = '3'
export const ABROAD_TEXT = '国外'

// 主体性质 =======> 非营利机构
export const ORGANIZATION = '4'
export const ORGANIZATION_TEXT = '国内（非营利机构）'

// 主体性质 =======> 港澳台
export const HKMCTW = '5';
export const HKMCTW_TEXT = '港澳台';

// 涉外业务类型 SRM_IS_OVERSEAS
export const NOT_INVOLVE = '0'; // 不涉及
export const OS_LGT = '1'; // 海外物流

// 承运商类型 ======> 自调车
export const SHUNTING_CAR = '00'
// 承运商类型 =====> 长合车
export const CHANGHE_CAR = '10'
// 承运商类型 =====> 车队长合车
export const FLEET_CHANGHE_CAR = '42'
// 承运商类型 =====> 城配长合车
export const CP_CHANGEHE_CAR = '190'
// 承运商类型 =====> 送装供应商
export const SZ_SUPPLIER = '200'
// 承运商类型 =====> 前置仓加盟网点
export const FRONT_WH_OUTLET = '202'

// 仓储-服务方式 =====> 仓库管理 SRM_CONTRACT_WH_SERVICE_TYPE
export const STO_MANAGE = '2'
// 仓储-服务方式 =====> 管装一体 SRM_CONTRACT_WH_SERVICE_TYPE
export const MANAGE_INSTALL = '4'

// 装卸-服务方式 =====> 装卸服务 SRM_CONTRACT_HANDLING_SERVICE_TYPE
export const LOAD_SERVICE = '3'

export const FORTY_FIVE_HUNDRED = 4500

// 车辆归属 SU_CAR_TYPE
export const CAR_OWNER_TYPE = {
    OWN: '1', // 自有
    AFFILIATION: '2', // 合作
    TEMPORARY: '3', // 临时
    LEASE: '4', // 租赁
}

// 服务方式 SRM_CONTRACT_WH_SERVICE_TYPE => 仓库租赁
export const WH_LEASE = '1'

// 是或否 SRM_YES_NO
export const SRM_YES = '1'
export const SRM_NO = '0'

// 接口前缀 =====> 运力中心导入导出
export const SRM_FILE_PRE = '/api-srm-file'
export const SRM_FILE = SRM_FILE_PRE + '/supplier'

// 接口前缀 =====> SRM
export const PFX = '/api-srm-web'

// 接口前缀 =====> 主数据
export const SRM = PFX + '/supplier'

// 接口前缀 =====> 保险
export const INSR = PFX + '/insurance'

// 分页属性
export const pageTag = {
    pageSize: 10,
    pageSizes: [10, 20, 30, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper',
}

// 业务分类 ======> 人资类
export const HRM = '10'

// 字段配置（供应商管理-类型配置）
export const BASE_CONFIG_FIELDS = [
    { name: '客户编号', code: 'customerCode', type: 'advance',
        displayCode: 'customerCode',
        params: {
            name: '客户编码',
            advanceLabel: '客户弹出框',
            advanceConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' },
            ],
            tableConfig: [
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerName', value: '客户名称' },
            ],
            // advanceUrl: '/ebCustomer/searchByEbCustomer',
            prefix: '/api-srm-web',
            method: 'post',
            advanceUrl: '/supplier/queryCrmCustomer',
            cbParams: ['customerName#customerName', 'customerCode#customerCode'],
        },
     },
    { name: '供应商英文名称', code: 'supplierNameEn', type: 'input' },
    { name: '法定代表人', code: 'corporateName', type: 'input' },
    { name: '负责人姓名', code: 'principalName', type: 'input' },
    { name: '身份证号', code: 'idCard', type: 'input' },
    { name: '企业注册地址', code: 'address', type: 'input' },
    { name: '社会信用代码', code: 'societyCreditCode', type: 'input' },
    { name: '营业执照注册号', code: 'businessLicenseNo', type: 'input' },
    { name: '营业执照注册起始日期', code: 'businessLicenseDateFrom', type: 'date' },
    { name: '营业执照注册终止日期', code: 'businessLicenseDateTo', type: 'date' },
    { name: '组织机构代码', code: 'orgCode', type: 'input' },
    { name: '税务登记号', code: 'taxRegistNo', type: 'input' },
    { name: '能否提供增值税发票', code: 'vatInvoiceFlag', type: 'select' },
    { name: '发票类型', code: 'invoiceType', type: 'multiple' },
    { name: '税点', code: 'taxRate', type: 'multiple' },
    { name: '付款方式', code: 'paymentType', type: 'select' },
    { name: '付款条件', code: 'paymentTerms', type: 'select' },
    { name: '注册资金(万元)', code: 'registerCapital', type: 'input' },
    { name: '成立日期', code: 'registerDate', type: 'date' },
    { name: '单位性质', code: 'nature', type: 'select' },
    { name: '国家/地区', code: 'countryCode', type: 'select' },
    { name: '省份/州', code: 'provinceCode', type: 'select' },
    { name: '城市', code: 'cityCode', type: 'select' },
    { name: '道路经营许可证有效日期', code: 'roadNoDate', type: 'date' },
    { name: '快递营运资质有效日期', code: 'deliveryTrafficAllowedDate', type: 'date' },
    {
        name: '分公司',
        code: 'companyCode',
        displayCode: 'companyName',
        type: 'advance',
        params: {
            name: '分公司',
            value: 'companyName',
            advanceConfig: [
                { prop: 'ALL', value: '全部' },
                { prop: 'companyNameCn', value: '分公司名称' },
                { prop: 'companyCode', value: '分公司编码' },
            ],
            advanceUrl: 'esCompany/popCompany',
            cbParams: ['companyCode', 'companyNameCn#companyName'],
            tableConfig: [
                { prop: 'companyCode', value: '分公司编码' },
                { prop: 'companyNameCn', value: '分公司名称' },
            ],
        },
    },
    {
        name: '服务平台',
        code: 'siteCode',
        displayCode: 'siteName',
        type: 'advance',
        params: {
            name: '服务平台',
            value: 'siteName',
            advanceConfig: [
                { prop: 'ALL', value: '全部' },
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
                { prop: 'escoCompanyNo', value: '服务平台编码' },
            ],
            advanceUrl: 'searchPlatform',
            cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            tableConfig: [
                { prop: 'escoCompanyNo', value: '服务平台编码' },
                { prop: 'escoCompanyNameCn', value: '服务平台名称' },
            ],
            advanceCascade: 'companyCode#companyCode',
        },
    },
    { name: '运力机制合作方式', code: 'cooperationMode', type: 'select' },
    { name: '合作伙伴起始日期', code: 'cooperationDate', type: 'date' },
    { name: '是否直控运力', code: 'isControlTransport', type: 'select' },
    { name: '供应商名称简称', code: 'supplierSimpleName', type: 'input' },
    { name: '服务类型', code: 'serviceType', type: 'select' },
    { name: '供应商来源途径', code: 'supplierSourceWay', type: 'select' },
    {
        name: '注册币种',
        code: 'registerCurrencyNew',
        displayCode: 'registerCurrencyName',
        type: 'advance',
        params: {
            name: '注册币种',
            value: 'registerCurrencyNew',
            advanceConfig: [
                { prop: 'nameCn', value: '币种名称' },
                { prop: 'currency', value: '币种代码' }
            ],
            advanceUrl: '/efCurrency/search',
            cbParams: ['currency#registerCurrencyNew', 'nameCn#registerCurrencyName'],
            tableConfig: [
                { prop: 'currency', value: '币种代码' },
                { prop: 'nameCn', value: '币种名称' }
            ],
        },
        overseaSwitch: true
    },
    { name: '注册英文地址', code: 'registerAddressEn', type: 'input', overseaSwitch: true },
    { name: '运输业务类型', code: 'transportBusinessType', type: 'multiple', overseaSwitch: true },
]

// 主体性质(供应商工作台-注册信息)
const [PROPERTY_LEGAL_PERSON, PROPERTY_INDIVIDUAL, PROPERTY_FOREIGN, PROPERTY_NPO, PROPERTY_HKMCTW] = ['1', '2', '3', '4', '5']
// 字段(供应商工作台-注册信息)
export const REGISTRY_MESSAGE_FIELDS = [
    {
        name: '供应商编号',
        code: 'supplierCode',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '供应商中文名称',
        code: 'supplierNameCn',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '供应商英文名称',
        code: 'supplierNameEn',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: false, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: false, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: false, disabled: true },
            { propertyNature: PROPERTY_NPO, required: false, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: false, disabled: true },
        ],
    },
    {
        name: '供应商类型',
        code: 'supplierType',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '主体性质',
        code: 'propertyNature',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
        // }, {
        //     name: '业务类型',
        //     code: 'businessType',
        //     type: 'select',
        //     auth: [
        //      { propertyNature: PROPERTY_LEGAL_PERSON, disabled: true },
        //      { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
        //      { propertyNature: PROPERTY_FOREIGN, disabled: true },
        //      { propertyNature: PROPERTY_NPO, disabled: true }
        //  ]
        // }, {
        //     name: '承运商类别',
        //     code: 'transType',
        //     type: 'select',
        //     auth: [
        //         { propertyNature: PROPERTY_LEGAL_PERSON, disabled: true },
        //         { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
        //         { propertyNature: PROPERTY_FOREIGN, disabled: true },
        //         { propertyNature: PROPERTY_NPO, disabled: true }
        //     ]
    },
    {
        name: '供应商状态',
        code: 'supplierStatus',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '客户编号',
        code: 'customerCode',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, disabled: true },
            { propertyNature: PROPERTY_NPO, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, disabled: true },
        ],
    },
    {
        name: '供应商英文名称',
        code: 'supplierNameEn',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, disabled: true },
            { propertyNature: PROPERTY_NPO, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, disabled: true },
        ],
    },
    {
        name: '单位性质',
        code: 'nature',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '法定代表人',
        code: 'corporateName',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '负责人姓名',
        code: 'principalName',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: true, disabled: true },
        ],
    },
    {
        name: '身份证号',
        code: 'idCard',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: true },
            { propertyNature: PROPERTY_NPO, required: false, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: true },
        ],
    },
    {
        name: '成立日期',
        code: 'registerDate',
        type: 'date',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: true },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '统一社会信用代码',
        code: 'societyCreditCode',
        type: 'input',
        auth: [{ propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true }],
    },
    // {
    //     name: '营业执照注册号',
    //     code: 'businessLicenseNo',
    //     type: 'input',
    //     auth: [
    //         { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true }
    //     ]
    // }, {
    //     name: '组织机构代码',
    //     code: 'orgCode',
    //     type: 'input',
    //     auth: [
    //         { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true }
    //     ]
    // }, {
    //     name: '税务登记号',
    //     code: 'taxRegistNo',
    //     type: 'input',
    //     auth: [
    //         { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true }
    //     ]
    // },
    {
        name: '营业执照注册起始日期',
        code: 'businessLicenseDateFrom',
        type: 'date',
        auth: [{ propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: false }],
    },
    {
        name: '营业执照注册终止日期',
        code: 'businessLicenseDateTo',
        type: 'date',
        auth: [{ propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: true }],
    },
    {
        name: '国家',
        code: 'countryCode',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '省份/州',
        code: 'provinceCode',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '城市',
        code: 'cityCode',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '企业注册地址',
        code: 'address',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '注册资金(万元)',
        code: 'registerCapital',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '能否提供增值税发票',
        code: 'vatInvoiceFlag',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '发票类型',
        code: 'invoiceType',
        type: 'multiple',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: false, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, required: false, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, required: false, disabled: false },
            { propertyNature: PROPERTY_NPO, required: false, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, required: false, disabled: false },
        ],
    },
    {
        name: '税点',
        code: 'taxRate',
        type: 'multiple',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: false, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, required: false, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, required: false, disabled: false },
            { propertyNature: PROPERTY_NPO, required: false, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, required: false, disabled: false },
        ],
    },
    {
        name: '付款方式',
        code: 'paymentType',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: false },
            { propertyNature: PROPERTY_NPO, required: true, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: false },
        ],
    },
    {
        name: '付款条件',
        code: 'paymentTerms',
        type: 'select',
        auth: [
            { propertyNature: PROPERTY_LEGAL_PERSON, required: true, disabled: false },
            { propertyNature: PROPERTY_INDIVIDUAL, required: true, disabled: false },
            { propertyNature: PROPERTY_FOREIGN, required: true, disabled: false },
            { propertyNature: PROPERTY_NPO, required: true, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, required: true, disabled: false },
        ],
    },
    {
        name: 'DUNS编号',
        code: 'dunsCode',
        type: 'input',
        auth: [
            { propertyNature: PROPERTY_FOREIGN, disabled: false },
            { propertyNature: PROPERTY_NPO, disabled: false },
            { propertyNature: PROPERTY_HKMCTW, disabled: false },
        ],
    },
    {
        name: '配送类型等级',
        code: 'dispatchSupplierRate',
        type: 'select',
        auth: [{ propertyNature: PROPERTY_LEGAL_PERSON, disabled: true }],
    },
]

// 供应商状态 SYS_SUPPLIERS_STATUS
export const SUPPLIER_STATUS = {
    POTENTIAL: '10', // 潜在
    QUALIFIED: '30', // 合格
    CLEAR: '35', // 清算
    QUIT: '40', // 退出
    APPEND: '50', // 新增
    REJECT: '60', // 驳回
}

// 审批状态 SRM_AUDIT_STATUS
export const AUDIT_STATUS = {
    DRAFT: '00', // 草稿
    PENDING: '10', // 审批中
    ADOPT: '20', // 通过
    REJECT: '30', // 驳回
    ABANDONMENT: '40', // 废弃
    WITHDRAW: '80', // 撤回
}

// 工人发薪预警 SALARY_REASON_AUDIT_STATUS
export const SALARY_REASON_AUDIT_STATUS = {
    PENDING: '3', // 审批中
    ADOPT: '20', // 通过
}

// 业务类型状态 SYS_SUPPLIER_SERVICES_STATUS
export const BUSINESS_TYPE_STATUS = {
    REGISTRY: '1', // 注册中
    WAITING: '2', // 待审批
    ADOPT: '3', // 审批通过
    REJECT: '4', // 驳回
    EFFECT: '5', // 业务生效
    QUIT: '9', // 业务退出
}

// 供应商 MIP 流程编码
export const FD_TEMPLATE_CODE = {
    QUIT: 'srm_supplier_quit',
    BLACK: 'srm_supplier_black',
}

// 供应商 MIP 流程ID
export const FD_TEMPLATE_ID = {
    QUIT: '1206472986610524160',
    BLACK: '1210370694501076992',
}

// 审批种类
export const APPROVAL_TYPES = {
    DRIVER: 'driver', // 司机审批
    CONTACT: 'contact', // 联系人审批
}

// 往来对账单对账单状态 SYS_DEALINGS_ACCOUNT_RESULT
export const DEALINGSACCOUNT = {
    NEW_CONSTRUCTION: 10, // 新建
    SENT_LETTER: 20, // 已发函
    SUPPLIER_CONFIRM_AGREE: 30, // 供方确认一致
    SUPPLIER_CONFIRM_DIFF: 40, // 供方确认差异
    DIFFERENCE_RECOVERED: 50, // 已回复差异
    STAMP_CONFIR: 60, // 盖章确认
    WITHDRAW: 70, // 撤回
    TERMINATION_RECONCILIATION: 80, // 终止对账
    UNDER_ARCHIVED: 90, // 归档中
    SUCESS_ARCHIVED: 91, // 归档成功
    FAIL_ARCHIVED: 92, // 归档失败
}

// 招标状态 BID_STATUS
export const BID_STATUS = {
    APPROVAL: '30', // 标书通过
    SCORING: '40', // 综合评分中
    SCORED: '43', // 综合评分完成
}

// 单据状态 SRM_INSURANCE_BA_AS_STATUS
export const BA_STATUS = {
    ADD: '10', // 新增
    EXAMINED: '20', // 已审核
    PREPAY: '30', // 预付款
    CLOSE: '40', // 关闭
    PAIED: '50', // 已付款
    SHARED: '60', // 已分摊
    CANCEL: '80', // 作废
}

// 保险-审批状态 SRM_INSURANCE_BA_MIP_STATUS
export const BA_MIP_STATUS = {
    ADD: '10', // 新建
    PENDING: '20', // 待审批
    SUCCESS: '30', // 审批通过
}

// 事故类型 SRM_INSURANCE_BA_TYPE
export const BA_TYPE = {
    FREIGHT: '10', // 货运
    PROPERTY: '20', // 财产
    VEHICLE: '40', // 车辆
}

// 事故单状态 SRM_INSURANCE_BA_STATUS
export const ACD_STATUS = {
    ADD: '10', // 新增
    SUBMIT: '20', // 材料递交
    REJECT: '21', // 材料驳回
    COMFIRM: '22', // 材料确认
    LOSS_ASSESS: '30', // 定损
    CLOSE: '50', // 回款结案
    REFUSE: '60', // 拒赔
    RMOVE: '70', // 销案
}

// 事故原因 SRM_INSURANCE_BA_WHY_HY
export const BA_WHY_HY = {
    CRASH: '10', // 撞车
}

// 财产成本状态 SRM_INSURANCE_BP_STATUS
export const BP_STATUS = {
    SUBMIT: '20', // 提交
}

// 运力寻源引入状态 SRM_SEARCH_INTRODUCTION_STATUS
export const INTRODUCTION_STATUS = {
    FOLLOWING: '1', // 意向跟进中
    IN_PROCESS: '2', // 引入流程中
    SUCCESS: '3', // 引入成功
    FAIL: '4', // 引入失败
}

// 需求状态 SRM_SEARCH_DEMAND_STATUS
export const DEMAND_STATUS = {
    ADD: '1', // 新增
    SEARCHING: '2', // 寻源中
}

// 寻源任务状态 SRM_SEARCH_STATUS
export const SEARCH_STATUS = {
    COMPLETE: '3', // 寻源完成
    TERNIMATE: '4', // 寻源终止
}

// 退出类型 SU_QUIT_TYPE
export const QUIT_TYPE = {
    ACTIVE: '2', // 主动退出
    PASSIVE: '3', // 被动退出
}
// 状态 SRM_ASSESSMENT_STATUS
export const ASSESSMENT_STATUS = {
    DRAFT: '0', // 草稿
    ENABLE: '1', // 启用
    DISABLE: '2', // 停用
}
// SYS_SU_MIP_AUDIT_TYPE
export const AUDIT_TYPE = {
    INTRODUCE: '1', // 供应商引入审批
    RUSH_ORDER: '36', // 抢单权限审批
}

// 仓库状态 SRM_WH_STATUS
export const WH_STATUS = {
    ADD: '0', // 新增
    QUALIFIED: '1', // 合格
}

// 保险数据隔离导出code
export const EXP_AUTH_TYPE_CODE = 'D20200928001'

// 运力数据来源系统 SRM_REGISTER_SOURCE
export const REGISTER_SOURCE = {
    LSRM: 'LSRM',
    LSP: 'LSP',
}

// 签署方式 SRM_SUPPLIER_DELEGATE_TYPE
export const PUSH_TYPE = {
    ALONE: '1', // 单独签署
    BATCH: '2', // 批量签署
}

// 成本招标项目状态 SRM_CUSTOMER_PROJECT_STATUS
export const CUSTOMER_PROJECT_STATUS = {
    ADD: '0', // 新增
    RESEARCH: '3', // 成本调研
    BIDDING: '5', // 竞标方案
    WINBID: '6', // 中标
    FAILBID: '7', // 落标
}

// SYS_BMS_NEW_MIP_STATUS mip流程状态
export const MIP_STATUS = {
    DRAFT: '00', // 草稿
    SUBMIT: '10', // 提交
    ADOPT: '20', // 通过
    REJECT: '30', // 驳回
    ABANDONMENT: '40', // 废弃
    WITHDRAW: '80', // 撤回
    PROCESSING: '90', // 处理中
    OTHER: '100', // 其他
}

// SYS_ACCOUNTS_TYPE 账户类型
export const ACCOUNT_TYPE = {
    BILL: 'BILL', // "票据户"
    CASH: 'CASH', // "现汇户"
    INBILL: 'INBILL', // "内部票据户"
    INCASH: 'INCASH', // 内部现汇户
    OTHER: 'OTHER', // 其他
    MIDEA_PAY: 'MIDEA_PAY', // 美的付
}

// 付款条件 BID_PAYMENT_TERMS
export const IMD_PAY = '1' // 立即付款

// BID_BUSINESS_TYPE 业务类型
export const BUSINESS_TYPE = {
    STORAGE_NUM,
    LOAD_AND_UNLOAD_NUM,
    TRANSPORTATION_NUM,
    DELIVERY_NUM,
    EXPRESS_NUM,
    OTHER_NUM: '6', // 其他业务
    RESELL_NUM: '7', // 资产转卖
    SERVICE_NUM: '8', // 服务
    ROBOT_NUM: '9', // 机器人
    HOME_DELIVERY_NUM,
    DEVICE_NUM,
    INSTALL_NUM: '12', // 安装
    CHAIN_NUM: '13', // 供应链管理
    DEVICE_LEASE_NUM,
    OILSALE_NUM: '15', // 油品销售
    RECYCLE_NUM: '16', // 绿色回收
    DECLARE_NUM: '22', // 报关
}

// SRM_BUSYNESS_TYPE_BLACK 业务类型（黑名单）
export const BUSYNESS_TYPE_BLACK = {
    STORAGE: '1', // 仓储类
    TRANSPORTATION: '2', // 运输类
    INFRASTRUCTURE: '3', // 基建设备类
    INTERNATIONAL: '4', // 国际物流
    OTHER: '5', // 其他
    DELIVERY: '6', // 配送类
}

// 创建来源
export const CREATE_SOURCE = {
    DEMAND: '1', // 运力需求
    DRIVER: '2', // 司机画像
    LAMINATION: '3', // 运力分层
}

// SRM_INSURANCE_LOSS_TYPE 损失类型
export const INSR_LOSS_TYPE = {
    QUALITY: '1',
    NOT_QUALITY: '2',
}

// 250410限制系统内部上传文件大小为15MB，限制OSS上传文件大小为30MB
export const OSS_FILE_MAX_SIZE = 30 // OSS上传文件最大限制
export const SRM_FILE_MAX_SIZE = 15 // 系统上传文件最大限制

// SRM_OPERATIONAL_QUALITY 运作质量
export const OPERATE_QUALITY = {
    NORMAL: '1', // 正常
    RECTIFY: '2', // 整改
    TALK: '3', // 整改约谈
    RISK: '5', // 运作风险
    HIGH_RISK: '6', // 高运作风险
}

// 在途联系类别
export const ON_WAY_CONTACT_CGR = {
    DRIVER: '1', // 司机
    SUPPLIER: '2', // 供应商
}
